/**
 * Feature Products API
 * Custom API calls for feature products
 */

/**
 * Get available devices for user
 * @param {number} productId
 * @returns {Promise<Object>}
 */
export async function getAvailableDevices(productId) {
  const response = await fetch(window.garrett?.ajaxurl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: new URLSearchParams({
      action: 'td_get_available_devices',
      security: window.garrett?.nonce,
      product_id: productId
    })
  })

  if (!response.ok) {
    throw new Error('Failed to get available devices')
  }

  return response.json()
}

/**
 * Store feature cart data (serial number, chip ID)
 * @param {string} cartItemKey
 * @param {string} serialNumber
 * @param {string} chipId
 * @returns {Promise<Object>}
 */
export async function storeFeatureCartData(cartItemKey, serialNumber, chipId) {
  const response = await fetch(window.garrett?.ajaxurl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: new URLSearchParams({
      action: 'store_feature_cart_data',
      security: window.garrett?.nonce,
      cart_item_key: cartItemKey,
      serial_number: serialNumber,
      chip_id: chipId
    })
  })

  if (!response.ok) {
    throw new Error('Failed to store feature cart data')
  }

  return response.json()
}
